import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header-landing',
  templateUrl: './header-landing.component.html',
  styleUrls: ['./header-landing.component.scss']
})
export class HeaderLandingComponent implements OnInit {
  @Input() pageConfig: any;

  constructor() { }

  ngOnInit() {
  }

}
